import { render, staticRenderFns } from "./TradingHistory.vue?vue&type=template&id=4903cbba&"
import script from "./TradingHistory.vue?vue&type=script&lang=js&"
export * from "./TradingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports